const ListCountry = {
    Qatar:require('../../images/country/Qatar.png'),
    Ecuador:require('../../images/country/Ecuador.png'),
    Senegal:require('../../images/country/senegal.png'),
    Netherlands:require('../../images/country/Netherlands.png'),
    England:require('../../images/country/England.png'),
    IR:require('../../images/country/IR-Iran.png'),
    USA:require('../../images/country/USA.png'),
    Wales:require('../../images/country/Wales.png'),
    Argentina:require('../../images/country/Argentina.png'),
    SaudiArabia:require('../../images/country/Saudi-Arabia.png'),
    MExico:require('../../images/country/MExico.png'),
    Poland:require('../../images/country/Poland.png'),
    France:require('../../images/country/France.png'),
    Australia:require('../../images/country/Australia.png'),
    Denmark:require('../../images/country/Denmark.png'),
    Tunisia:require('../../images/country/Tunisia.png'),
    Spain:require('../../images/country/Spain.png'),
    CostaRica:require('../../images/country/Costa-Rica.png'),
    Germany:require('../../images/country/Germany.png'),
    Japan:require('../../images/country/Japan.png'),
    Belgium:require('../../images/country/Belgium.png'),
    Canada:require('../../images/country/Canada.png'),
    Morocco:require('../../images/country/Morocco.png'),
    Croatia:require('../../images/country/Croatia.png'),
    Brazil:require('../../images/country/Brazil.png'),
    Serbia:require('../../images/country/Serbia.png'),
    Switzerland:require('../../images/country/Switzerland.png'),
    Cameroon:require('../../images/country/Cameroon.png'),
    Portugal:require('../../images/country/Portugal.png'),
    Ghana:require('../../images/country/Ghana.png'),
    Uruguay:require('../../images/country/Uruguay.png'),
    SouthKorea:require('../../images/country/South-Korea.png'),
}

export default ListCountry